import { render, staticRenderFns } from "./virtualContract.vue?vue&type=template&id=ba0ce754&scoped=true"
import script from "./virtualContract.vue?vue&type=script&lang=js"
export * from "./virtualContract.vue?vue&type=script&lang=js"
import style0 from "./virtualContract.vue?vue&type=style&index=0&id=ba0ce754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ce754",
  null
  
)

export default component.exports